import compact from 'lodash/compact';
import uniq from 'lodash/uniq';
import { useQuery } from '@tanstack/react-query';

import { userQueryOptions } from '@user/queries/userQueries';
import { medicalCaseQueryOptions } from '@store/MedicalCase/queries/medicalCaseQueries';

import { computeTaskPermissions, type TaskPermissions } from '../utils/taskPermissions';
import type { TaskFormState } from '../types';

export function useTaskPermissions(state: TaskFormState): TaskPermissions {
    const userIds = uniq(
        compact([state.authUserId, state.authorId, state.requesterId, ...state.executorIds, state.actualExecutorId]),
    );
    const { data: users = [] } = useQuery({
        ...userQueryOptions.list({ ids: userIds }),
        enabled: userIds.length > 0,
    });
    const { data: medicalCases = [] } = useQuery(medicalCaseQueryOptions.byIds(state.medicalCaseIds));

    return computeTaskPermissions(state, {
        getUser: id => (id ? users.find(user => user.id === id) : undefined),
        medicalCases,
    });
}
